import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';
import { parseNabidkySmlouvySearch } from '@/lib/list-search';

const NabidkaDetail = lazy(() =>
  import('@/modules/ojeta-vozidla/NabidkaDetail').then((m) => ({ default: m.NabidkaDetail })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/ojeta-vozidla/nabidky/$id',
  component: () => (
    <Suspense fallback={null}>
      <NabidkaDetail />
    </Suspense>
  ),
  validateSearch: parseNabidkySmlouvySearch,
});
